import {STATUS} from '@jobseeker/common-core/constants';
import axiosInterceptorInstance from '@jobseeker/common-core/helpers/axiosInterceptor';

const axios = axiosInterceptorInstance(
  `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_JOB_SERVICE}`
);

const getRecruiters = async (
  path: string,
  queryParams = {name: 'A'}
): Promise<any> => {
  try {
    const response: any = await axios.get(`${path}`, {params: queryParams});

    if (response[STATUS] === 200) {
      return response['data'];
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data.error.message,
        code: error.response?.data.error.statusCode,
      },
    };
  }
};

const getCompanyLogo = async (
  path: string,
  queryParams: {jobId: string} = {jobId: ''}
): Promise<any> => {
  try {
    const response: any = await axios.get(`${path}`, {params: queryParams});

    if (response.status === 200) {
      return response.data;
    }
    return {};
  } catch (error: any) {
    return {
      error: {
        message: error.response?.data?.error?.message,
        code: error.response?.data?.error?.statusCode,
      },
    };
  }
};

const recruiterService = {
  getRecruiters,
  getCompanyLogo,
};

export default recruiterService;
